<template>
  <div class="wrap personal-wrap collection-wrap">
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <empty imgpath="/static/images/empty_collection_3x.png" emptytext="您还没有收藏商品" btntext="去逛一逛" btnurl="/main/home" v-if="listPageGoodsFav.length==0 && !loadShow"></empty>
    <div class=" flex-column" v-show="listPageGoodsFav.length!=0 && !loadShow">
      <div class="grid-tip">
        你收藏了
        <label class="primary">{{size}} </label>个商品
        <label class="fr blue" @click="editstate=true" v-if="!editstate">编辑</label>
        <label class="fr blue" @click="editstate=false" v-else>完成</label>
      </div>
      <div class="collection-list flex-item" v-bind:class="[editstate?'edit-state':' ']">
        <!-- <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>      -->
        <mu-list>
          <myOrdersItem :width="150" :height="150" v-for="(pageGoodsShow,indexNumber) in listPageGoodsFav" :cartitem="pageGoodsShow" :key="indexNumber" :selvalue="checkboxsel" :isCheckBox="'true'" :isRightTriggle="'true'" @on-result-change="onResultChange">
          </myOrdersItem>
          
        </mu-list>
        <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
        <p class="none-goods" v-if="(lastPageNo == currentPage && !loadShow) || (size ==0 && !loadShow) ">没有更多商品啦~</p>
      </div>

      <div class="cartBottom" v-if="editstate">
        <mu-checkbox name="group" id="all" v-model='allChecked' class="list-radio" @change="selectAll($event)" label="全选" />
        <div class="go" @click="deleteItem" v-bind:class="[checkboxsel.length == 0 ?'disabledbtn':'primarybtn']">取消收藏</div>
      </div>
    </div>
    <mu-dialog :open="isDelete" title="取消收藏" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close=" isDelete = false;">
      确定对选中的{{checkboxsel.length}}个产品取消收藏？
      <mu-flat-button slot="actions" @click="isDelete = false" primary label="否" />
      <mu-flat-button slot="actions" primary label="确定" @click="closedeleteAddress()" />
    </mu-dialog>
    <mu-toast v-if="toast1" message="当前还没有选中商品" class="custom-toast" />
    <mu-toast v-if="toast2" message="删除成功!" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import empty from '@components/empty/empty';
import { mapActions } from 'vuex';
export default {
  data() {
    const cartData = []
    for (let i = 0; i < 11; i++) {
      cartData.push({
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: i,
      })
    }
    return {
      loadShow: true,
      Height: document.body.clientHeight - 40,
      cartData,
      checkboxsel: [], //选中的favId
      allChecked: false, //全选状态
      editstate: false, //编辑状态
      isDelete: false, //删除弹框
      toast1: false, //没有选中提示框
      toast2: false, //删除成功提示框
      num: 10,
      loading: false, //加载
      scroller: null,
      refreshing: false,
      trigger: null,
      listPageGoodsFav: [], //获取我的收藏
      pageNo: 1,
      pageSize: 10,
      currentPage: 1,//当前页
      lastPageNo:1,//总共页面数量
      size: null, //当前收藏条数
      goodsName: '', //商品名称
    }
  },
  watch: {},
  methods: {
    ...mapActions({
      pageGoodsFav: 'pageGoodsFav', //获取收藏信息
      delGoodsFavBatch: 'delGoodsFavBatch', //批量删除我的收藏
      delGoodsFav: 'delGoodsFav', //删除我的收藏
    }),
    // 加载更多
    loadMore() {
      if(this.lastPageNo == this.pageNo){
        this.loading = false;
      }else{
        this.loading = true;
        this.pageNo ++ ;
        this.getPageGoodsFav();
        setTimeout(() => {
          this.loading = false
       }, 2000)
      }
      
    },
    refresh() {
      this.refreshing = true
      setTimeout(() => {
        const list = []
        for (let i = this.num; i < this.num + 10; i++) {
          list.push({
            id: '1',
            title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
            img: "/static/images/headImg.jpg",
            describe: "油漆门特权订金（特价门型不可用）",
            price: i,
          })
        }
        this.listPageGoodsFav = list
        this.num += 10
        this.refreshing = false
      }, 2000)
    },
    //子组件传数据   判断并勾选
    onResultChange(val) {
      this.checkboxsel = val;
      if (this.checkboxsel.length === this.listPageGoodsFav.length) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
      //console.log("需要修改的数据", this.checkboxsel)
    },
    //点击数据列表时间
    clickItem: function(id) {
      if (this.editstate) { //编辑状态，勾选
        // 编辑状态 点击列表
        // 如未勾选   勾选对应的
        // 已勾选   则取消勾选
        let isSel = false;
        var _this = this;
        for (var i = 0; i < _this.checkboxsel.length; i++) {
          if (_this.checkboxsel[i] == id) {
            _this.checkboxsel.splice(i, 1);
            isSel = true;
          }
        }
        if (!isSel) {
          this.checkboxsel.push(id);
        }
      } else { //进入产品详情页
        this.$router.push({
          path: '/main/myredpack'
        })
      }
    },
    //取消收藏
    deleteItem() {
      if (this.checkboxsel.length > 0) {
        this.isDelete = true;
      } else {
        this.toast1 = true;
        if (this.toast1Timer) clearTimeout(this.toast1Timer)
        this.toast1Timer = setTimeout(() => { this.toast1 = false }, 1500)
      }
    },
    //关闭弹框  判断是批量删除还是单个删除
    closedeleteAddress() {
      if (this.checkboxsel.length <= 1) {
        this.getDelGoodsFav(this.checkboxsel[0]);
      } else if (this.checkboxsel.length >= 2) {
        this.getDelGoodsFavBatch(this.checkboxsel);
      }
    },
    //选择全部
    selectAll(checked) {
      var _this = this;
      if (checked) { //实现反选
        _this.checkboxsel = [];
        _this.listPageGoodsFav.forEach(function(item) {
          _this.checkboxsel.push(item.favId);
        });
      } else { //实现全选
        _this.checkboxsel = [];
      }
    },
    //批量删除api
    getDelGoodsFavBatch(favId) {
      this.delGoodsFavBatch(favId).then(res => {
        this.isDelete = false;
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false }, 1500);
        this.getPageGoodsFav(this.goodsName, this.pageNo, this.pageSize);
      }).catch(error => {})
    },
    //删除我的收藏
    getDelGoodsFav(favId) {
      this.delGoodsFav(favId).then(res => {
        this.isDelete = false;
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false }, 1500);
        this.getPageGoodsFav(this.goodsName, this.pageNo, this.pageSize);
      })
    },
    //获取我的收藏列表
    getPageGoodsFav() {
      this.pageGoodsFav([this.goodsName, this.pageNo, this.pageSize]).then(res => {
        this.loadShow = false;
        res.target.result.forEach(item => {
           this.listPageGoodsFav.push(item)
        })
        // this.listPageGoodsFav = res.target.result;
        this.size = res.target.totalCount;
        this.lastPageNo = Number(res.target.lastPageNo);
        this.currentPage = Number(res.target.currentPageNo);
      });
    },
  },
  components: {
    menus,
    myOrdersItem,
    empty
  },
  mounted() {
    this.scroller = document.querySelectorAll('.collection-list')[0]
    console.log(this.scroller)
    // this.scroller = this.$el;
    this.trigger = this.$el
  },
  created() {
    //获取我的收藏列表
    this.getPageGoodsFav([this.goodsName, this.pageNo, this.pageSize]);
  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';

</style>



// WEBPACK FOOTER //
// mycollection.vue?87047260